const _rawUrl = (import.meta.env.VITE_API_URL as string | undefined) ?? ''
const BASE = _rawUrl.replace(/^﻿/, '').trim() || 'http://localhost:3001'

const TOKEN_KEY = 'mayo_token'

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token: string | null): void {
  if (token) localStorage.setItem(TOKEN_KEY, token)
  else localStorage.removeItem(TOKEN_KEY)
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const token = getToken()
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  })

  if (res.status === 401) {
    setToken(null)
    window.location.href = '/login'
    throw new Error('No autorizado')
  }

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }))
    throw new Error((err as { error?: string }).error ?? `HTTP ${res.status}`)
  }

  if (res.status === 204) return undefined as unknown as T
  return res.json() as Promise<T>
}

export const api = {
  get:  <T>(path: string)                 => request<T>('GET',    path),
  post: <T>(path: string, body: unknown)  => request<T>('POST',   path, body),
  put:  <T>(path: string, body?: unknown) => request<T>('PUT',    path, body),
  del:  <T>(path: string)                 => request<T>('DELETE', path),

  // Devuelve el Response crudo (para streaming SSE)
  stream: (path: string, body: unknown) => {
    const token = getToken()
    return fetch(`${BASE}${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(body),
    })
  },
}
